<template>
    <el-dialog :title="$t(title)" :visible.sync="dialogOrgVisible" :before-close="orgDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" height="800px" width="280px" append-to-body >
        <td-orgtree :lazyloading="lazyloading" :height="treeHeight" :draggable=false :isDbClick="isDbClick" :isClick="isClick" @getCheckedNodes="getCheckedNodes" :imgloading=false
            ref="TdDialogTree" @onDbClickTree="onDbClickTree" @onClick="onDbClickTree" :checkStrictly="checkStrictly" :checkNodes="checkNodes" :showBox="true">
        </td-orgtree>
            <div  style="text-align:center">
                <td-button type="primary" size="small" @click="submitForm()">{{$t('common.CONFIRM')}}</td-button>
                <td-button size="small" @click="orgDialogClose">{{$t('common.CANCAL')}}</td-button>
            </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: [String, String]
        },
        dialogOrgVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        height: {
            type: Number,
            default: function() {
                return 600;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        width: {
            type: Number,
            default: function() {
                return 220;
            }
        }
    },
    mounted() {},
    data() {
        return {
            selectedNodes: []
        };
    },

    methods: {
        // 提交数据
        submitForm(formName) {
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
            this.$emit('selected', this.selectedNodes);
            this.orgDialogClose();
        },
        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
        },
        onDbClickTree() {},
        getCheckedNodes() {
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
        }
    }
};
</script>
<style >
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
